import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

/**
Le textblock sono input in lettura, che non si possono modificare.
Si può però selezionare il testo per fare una copia.
 */
const Textblock = ({
  children, className, disabled, label, text, ...others
}) => (
  <div
    className={cns(
      'textblock',
      {
        'textblock--disabled': disabled,
      },
      className,
    )}
    {...others}
  >
    <span className="textblock__label">{label}</span>
    <span className="textblock__text">{text}</span>
    {children}
  </div>
);

Textblock.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se il componente è disabilitato */
  disabled: PropTypes.bool,
  /** Etichetta visualizzata dal componente */
  label: PropTypes.string,
  /** Testo visualizzato dal componente */
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),

};

Textblock.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  label: '',
  text: '',
};

export default Textblock;
